module.exports = "<span class=\"font-roboto-bold font-size-20\" mat-dialog-title>\n    {{ title }}\n</span>\n<mat-dialog-content>\n    <div class=\"text-center\">\n        <div [innerHTML]=\"content\"></div>\n    </div>\n</mat-dialog-content>\n<mat-dialog-actions>\n    <div class=\"btn-group m-auto\" aria-label=\"Basic example\">\n        <button type=\"button\" class=\"btn btn-green\" (click)=\"ok()\">Aceptar</button>\n    </div>\n</mat-dialog-actions>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/alert/alert.component.html
// module id = ./src/app/components/alert/alert.component.html
// module chunks = main